import { RealtimeHealthStatus } from "../constants/healthStatus";

export function getServerStatusMessage(health, time) {
    switch (health) {
        case RealtimeHealthStatus.HEALTHY:
            return time || "در حال برقراری ارتباط...";

        case RealtimeHealthStatus.WARNING:
            return "ارتباط با اختلال همراه است";

        case RealtimeHealthStatus.DEAD:
            return "ارتباط با سرور برقرار نیست";

        case RealtimeHealthStatus.CONNECTING:
        default:
            return "در حال برقراری ارتباط...";
    }
}